import { Action, actionCreatorFactory } from 'typescript-fsa'

import { Form } from 'mytours-read-api-typescript'

const actionCreator = actionCreatorFactory('Form')

export interface LoadFormParams {
	id: number
	version: number
	language: string
}
export type LoadFormAction = Action<LoadFormParams>
export const loadForm = actionCreator<LoadFormParams>('LOAD_FORM')

export interface LoadedFormResult {
	id: number
	version: number
	form: Form
}
export type LoadedFormResultAction = Action<LoadedFormResult>

export const loadedFormFromDisk = actionCreator<LoadedFormResult>('LOADED_FORM_FROM_DISK')

export const removeFormFromDisk = actionCreator<LoadFormParams>('REMOVE_FORM_FROM_DISK')
